import * as React from 'react';
import { useHistory } from '../../../Hooks/Features/HistoryData/useHistory';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import Pagination from '../../../components/CommonCompo/Pagination/pagination';
import {
  SkeletonContainer,
  SkeletonDataTable,
} from "../../../components/Loader/Loader";

export const HistoryData = () => {
  const { tableList, getHistoryData, totalRecords, totalPages, currentPage,
    displayPageOutOfTotal, handlePageChange, rowData, columnDefs, tableName, loader } = useHistory();


  return (

    <div className='container-fluid'>

      <div className='row'>
        <div className='col-md-12 col-12'>
          <h5>History Data</h5>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-4'>
          <span className='master-list' style={{ overflow: "auto" }}>
            {!loader.listLoader ? tableList.map((name, index) => (
              <div key={index} className="table-row" onClick={() => getHistoryData(name?.table_name, 0)}>
                {name?.table_name.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
              </div>
            )) :
              <SkeletonContainer />
            }
          </span>
        </div>

        {tableName !== '' && <div className='col-md-8'>
          <h5>{tableName.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</h5>
          <div className="ag-theme-alpine aggrid-container" style={{ height: 'calc(100vh - 180px)' }}>
            {loader.gridLoader ? (<SkeletonDataTable numSkeletons={10} />) :
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                rowHeight={24}
                headerHeight={30}
              />}
          </div>
          <Pagination
            totalRecords={totalRecords}
            totalPages={totalPages}
            currentPage={currentPage}
            displayPageOutOfTotal={displayPageOutOfTotal}
            onPageChange={handlePageChange}
          />

        </div>}
      </div>
    </div>

  );
};



export default HistoryData;